// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".573.0.0." + {2239: "9706f8c6282a0e1d",2733: "8f3e42e6c71ad248",2944: "89a9e59002535163",5233: "62e041bf8e95b759",5338: "da89451a27b7f5b7",8756: "bdfa09938215ca87",9289: "dbb34499bdcd16e7",}[chunkId] + ".css"
}